// extracted by mini-css-extract-plugin
module.exports = {"currencyContainer":"InvoicesTable_currencyContainer__1ItCd","tablePaymentScheduleDetail":"InvoicesTable_tablePaymentScheduleDetail__weTAs"};